import { useEffect, useRef } from 'react'
import { useUser } from '@supabase/auth-helpers-react'
import { useLocation } from 'react-router-dom'

export default function useRybbit() {
    const user = useUser()
    const location = useLocation()
    const identified = useRef(false)

    useEffect(() => {
        if (import.meta.env.DEV) return
        if (!window.rybbit || !user) return

        if (!identified.current) {
            window.rybbit.identify(user.id, {
                name: user.user_metadata?.name,
                email: user.email,
            })
            identified.current = true
        }

        window.rybbit.pageview()
    }, [user, location.pathname])
}
